import React, { useEffect, useState, useCallback } from 'react';
import { Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { api } from './adminApi';

const EMPTY = { code: '', type: 'percent', value: 10, min_order: 0, max_uses: 0, active: true };

export const AdminDiscounts = () => {
  const [rows, setRows] = useState([]);
  const [d, setD] = useState(EMPTY);
  const load = useCallback(async () => setRows((await api.discounts()).discounts || []), []);
  useEffect(() => { load(); }, [load]);
  const add = async () => { try { await api.saveDiscount(d); setD(EMPTY); toast.success('Code added'); load(); } catch (e) { toast.error(e.message); } };
  return (
    <div className="space-y-5" data-testid="admin-discounts">
      <div className="rounded-lg border border-[var(--si-line)] p-4">
        <p className="font-bold mb-3">New discount code</p>
        <div className="grid md:grid-cols-5 gap-2 text-sm">
          <input placeholder="CODE" value={d.code} onChange={(e) => setD({ ...d, code: e.target.value.toUpperCase() })} className="si-input !py-2" data-testid="disc-code" />
          <select value={d.type} onChange={(e) => setD({ ...d, type: e.target.value })} className="si-input !py-2"><option value="percent">% off</option><option value="fixed">₹ off</option></select>
          <input type="number" placeholder="Value" value={d.value} onChange={(e) => setD({ ...d, value: Number(e.target.value) })} className="si-input !py-2" data-testid="disc-value" />
          <input type="number" placeholder="Min order ₹" value={d.min_order} onChange={(e) => setD({ ...d, min_order: Number(e.target.value) })} className="si-input !py-2" />
          <button onClick={add} disabled={!d.code} className="si-btn si-btn-primary !py-2" data-testid="disc-add">Add code</button>
        </div>
      </div>
      <table className="w-full text-sm">
        <thead><tr className="border-b border-[var(--si-line)] text-left text-xs uppercase tracking-wider text-[var(--si-grey)]"><th className="py-2">Code</th><th>Type</th><th>Value</th><th>Min order</th><th>Uses</th><th></th></tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.code} className="border-b border-[var(--si-line)]">
              <td className="py-2 font-mono font-bold">{r.code}</td><td>{r.type}</td><td>{r.value}{r.type === 'percent' ? '%' : '₹'}</td>
              <td>₹{r.min_order}</td><td>{r.usage_count || 0}</td>
              <td><button onClick={async () => { await api.delDiscount(r.code); load(); }} className="hover:text-red-600" data-testid={`disc-del-${r.code}`}><Trash2 className="w-4 h-4" /></button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminDiscounts;
